import { SparklesIcon } from "@heroicons/react/24/outline";
import { TypeAnimation } from "react-type-animation";

import { useTranslation } from "react-i18next";

import ChatInput from "@/components/chat/ChatInput";
import { isMobileDevice } from "@/utils/platform";

interface ChatFieldProps {
  submitQuestion: (rawQuestion: string, options?: { isNewConversation?: boolean }) => Promise<void>;
}

export default function ChatField({ submitQuestion }: ChatFieldProps) {
  const { t } = useTranslation();

  const exampleQuestions = [t("chat.question1"), t("chat.question2"), t("chat.question3"), t("chat.question4")];

  return (
    <ChatInput
      className="border-2 border-dobu-orange md:border-gray-300 pl-9 placeholder:opacity-0"
      name="question"
      placeholder={t("chat.talkToYourHome")}
      onSend={(question) => submitQuestion(question)}
      autoFocus={!isMobileDevice()}
    >
      <SparklesIcon className="w-6 h-6 inline ml-2 absolute left-0 top-2.5 text-dobu-orange md:text-gray-400 pointer-events-none" />
      <TypeAnimation
        sequence={[
          exampleQuestions[0],
          3000,
          exampleQuestions[1],
          3000,
          exampleQuestions[2],
          3000,
          exampleQuestions[3],
          3000,
        ]}
        className="absolute left-0 right-11 ml-10 truncate text-gray-400 pointer-events-none peer-focus:hidden peer-[:not(:placeholder-shown)]:hidden"
        wrapper="span"
        speed={25}
        repeat={Infinity}
      />
    </ChatInput>
  );
}
